import { ListContextProvider } from './__internal__/';
import { BaseList } from './__internal__/BaseList';
import './List.css';

/**
 * The List component provides a layout grid of list items.
 *
 * @component
 * @param {ListProps} props the ListProps properties
 * @returns the List element
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const List = props => {
  return /*#__PURE__*/_jsx(ListContextProvider, {
    children: /*#__PURE__*/_jsx(BaseList, {
      ...props
    })
  });
};
//# sourceMappingURL=List.js.map